import React from "react";
import { Provider } from "react-redux";
import store from "./store";
import Main from "./Main.js";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";

const App = () => {
  return (
    <Provider store={store}>
      <Main />
    </Provider>
  );
};

export default App;
